import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  Container,
  Card,
  Button,
  Alert,
  Spinner,
  Image,
} from "react-bootstrap";
import { MdLockOutline } from "react-icons/md";
import toast from "react-hot-toast";
import { showToast } from "../services/toast";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Please fill in all fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const result = await login(email, password);
      if (result.success) {
        showToast("success", "Login successful!");
        navigate("/");
      } else {
        setError(result.message);
      }
    } catch (error) {
      setError("An error occurred during login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex login-page align-items-center">
      <Container style={{ maxWidth: 540 }}>
        <Card className="shadow-lg">
          <Card.Body className="p-4 d-flex flex-column align-items-center">
            <figure className="">
              <Image src="./logo.png" alt="logo" />
            </figure>
            {/* <h4>Welcome Back</h4> */}
            <div className="text-muted mb-3">
              Sign in to your account to continue
            </div>
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              {error && (
                <Alert variant="danger" className="mb-2">
                  {error}
                </Alert>
              )}
              <div className="mb-3">
                <label className="form-label">Email Address</label>
                <input
                  className="form-control"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  className="form-control"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="w-100 py-2 fw-semibold"
                size="lg"
              >
                {loading ? <Spinner size="sm" animation="border" /> : "Sign In"}
              </Button>
            </form>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Login;
